/**
 * Onboarding types
 */
export const ONBOARDING_STEPS = {
    WELCOME: 1,
    PROFILE_SETUP: 2,
    FIRST_MEETING: 3,
    FEATURES_OVERVIEW: 4,
    COMPLETION: 5,
};
export const TOTAL_STEPS = 5;
//# sourceMappingURL=onboarding.js.map